/* global lozad */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll.js' // スムーズスクロール
import Swiper from 'swiper' // Swiper

jQuery(function($) {
  let name = 'menu' // このIDを基準としたアコーディオン
  $('#' + name + '-open,#' + name + '-close').on('click', function() {
    $('#' + name + '-open,#' + name + '-close,#' + name).toggleClass('active')
    $('body').toggleClass('lock')
  })

  /*
  ███████ ██     ██ ██ ██████  ███████ ██████
  ██      ██     ██ ██ ██   ██ ██      ██   ██
  ███████ ██  █  ██ ██ ██████  █████   ██████
       ██ ██ ███ ██ ██ ██      ██      ██   ██
  ███████  ███ ███  ██ ██      ███████ ██   ██
  */
  //
  if ($('.mv-container')[0]) {
    // Swiperコンテナを検出したら実行
    /* eslint-disable no-unused-vars */
    let mySwiper = new Swiper('.mv-container', {
      // eslint-disable-line
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      }
    })
  }

  /*
  ██████  ████████ ███    ██
  ██   ██    ██    ████   ██
  ██████     ██    ██ ██  ██
  ██   ██    ██    ██  ██ ██
  ██████     ██    ██   ████
  */

  $('.md-btn.bars')
    .not('.active')
    .on('mouseover', function() {
      $(this).addClass('active')
      $(this).on('animationend webkitAnimationEnd', function() {
        $(this).removeClass('active')
      })
    })

  $('.btn-wrap')
    .not('.wrap-active')
    .on('mouseover', function() {
      $(this)
        .find('.md-btn.bars')
        .addClass('active')
      $(this).on('animationend webkitAnimationEnd', function() {
        $(this)
          .find('.md-btn.bars')
          .removeClass('active')
      })
    })

  /*
  ████████ ██████  ██    ██ ███    ██ ██   ██  █████
     ██    ██   ██ ██    ██ ████   ██ ██  ██  ██   ██
     ██    ██████  ██    ██ ██ ██  ██ █████    █████
     ██    ██   ██ ██    ██ ██  ██ ██ ██  ██  ██   ██
     ██    ██   ██  ██████  ██   ████ ██   ██  █████
  */
  function trunk8() {
    $('.js-t8,.bread').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize ', function() {
    trunk8()
  })

  /*
  ███████  █████   ██████ ███████ ██████   ██████   ██████  ██   ██
  ██      ██   ██ ██      ██      ██   ██ ██    ██ ██    ██ ██  ██
  █████   ███████ ██      █████   ██████  ██    ██ ██    ██ █████
  ██      ██   ██ ██      ██      ██   ██ ██    ██ ██    ██ ██  ██
  ██      ██   ██  ██████ ███████ ██████   ██████   ██████  ██   ██
  */
  $(window).on('resize', function() {
    // Facebook Page Plugin自動リサイズ
    const htmlStr = $('#pageplugin').html()
    const resWid = $(window).width()
    let winWid = resWid
    let timer = null
    if (winWid !== resWid && resWid < 500) {
      clearTimeout(timer)
      timer = setTimeout(function() {
        $('#pageplugin').html(htmlStr)
        window.FB.XFBML.parse()
        winWid = $(window).width()
      }, 500)
    }
  })

  /*
  ███████  ██████ ██████   ██████  ██      ██
  ██      ██      ██   ██ ██    ██ ██      ██
  ███████ ██      ██████  ██    ██ ██      ██
       ██ ██      ██   ██ ██    ██ ██      ██
  ███████  ██████ ██   ██  ██████  ███████ ███████
  */

  if ($('#top-page')[0]) {
    // TOPページのみ実行
    let scrollTimer = null
    $(window).on('load scroll resize', function() {
      // 画面に収まった要素をアクティブ
      clearTimeout(scrollTimer)
      scrollTimer = setTimeout(function() {
        if ($(window).scrollTop() > $(window).innerHeight() / 2) {
          // ページ最上部からのスクロール量 + ビューポートの半分 = 画面の中間
          $('#header').addClass('active')
        } else {
          $('#header').removeClass('active')
        }
      }, 50) // トリガー操作終了から指定ミリ秒待つ（連続実行防止）
    })
  }

  /*
  ██       ██████  ███████  █████  ██████
  ██      ██    ██    ███  ██   ██ ██   ██
  ██      ██    ██   ███   ███████ ██   ██
  ██      ██    ██  ███    ██   ██ ██   ██
  ███████  ██████  ███████ ██   ██ ██████
  */
  lozad('.lozad,.chain', {
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()

  $('.mag-popup').magnificPopup({
    //  delegate:'',    //子要素を開く場合のセレクタ
    closeMarkup: '', // 閉じるボタンのマークアップ（空にして自作推奨）
    type: 'inline' // iframe/image/inline/ajax
    //  disableOn:720,  //画面解像度が指定以下なら動作しない
    //   gallery:{      //ギャラリーオプション
    //     enabled:true
    //   }
    // callbacks: {
    //   beforeOpen: function() {
    //   },
    //   resize: function() {
    //   },
    //  open: function() {
    //    $('body').addClass('blur')
    //  },
    //  beforeClose: function() {
    //    $('body').removeClass('blur')
    //  },
    //   afterClose: function() {
    //   },
    // }
  })
  $('.mfp-btn').on('click', function() {
    $.magnificPopup.close()
  })
  // タブ切り替え
  let tabList = '.js-thumb-img'
  let contentList = '.js-main-img'
  $(tabList)
    .children('li')
    .click(function() {
      let index = $(this)
        .parent()
        .children('li')
        .index(this)
      $(tabList + ',' + contentList).each(function() {
        $(this)
          .children('li')
          .removeClass('active')
          .eq(index)
          .addClass('active')
      })
    })
})
